import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useTitle } from '../../context/TitleContext';
import { Row, Col } from 'react-bootstrap';
import AddWarehouse from './components/AddWarehouse';
import '../../styles/products.scss';

const WarehouseEdit = () => {
  const { id } = useParams();
  const { setTitle } = useTitle();

  useEffect(() => {
    setTitle('Modifier l\'Entrepôt');
  }, [setTitle]);

  return (
    <div className="warehouse-edit-page">
      <Row className="g-3">
        <Col xl={12} lg={12}>
          <AddWarehouse isEdit={true} warehouseId={id} />
        </Col>
      </Row>
    </div>
  );
};

export default WarehouseEdit;
